import { format } from "date-fns";

// Internal/API dates stay "YYYY-MM-DD" (or full ISO timestamps) — these only affect what's
// shown on screen, formatted as MM/DD/YY per the app's display convention.
export const toIsoDate = (d) => format(d, "yyyy-MM-dd");

export const isoToDate = (iso) => {
  const [y, m, d] = iso.split("-").map(Number);
  return new Date(y, m - 1, d);
};

export const formatMDY = (isoOrTimestamp) => {
  if (!isoOrTimestamp) return "";
  const datePart = isoOrTimestamp.slice(0, 10); // works for both "YYYY-MM-DD" and full ISO timestamps
  return format(isoToDate(datePart), "MM/dd/yy");
};
